import { ShoppingCartItemTypeEnum } from "../generated/graphql";
import { take } from "../util/takePayload";
export const getNew = (itemId) => ({
    itemType: ShoppingCartItemTypeEnum.Ticket,
    itemId,
    count: 0,
});
export const newSeatTicket = (itemId) => ({
    itemType: ShoppingCartItemTypeEnum.SeatTicket,
    itemId,
    count: 0,
});
export const newDonation = (amount) => ({
    itemType: ShoppingCartItemTypeEnum.Donation,
    amount,
});
export const newDiscount = (code) => ({
    itemType: ShoppingCartItemTypeEnum.Discount,
    details: { code },
});
export const newPresale = (code) => ({
    itemType: ShoppingCartItemTypeEnum.Presale,
    details: { code },
});
export const fromShoppingCartItem = (item) => take(item, 'count', 'itemId', 'itemType', 'amount', 'details');
//# sourceMappingURL=ShoppingCartItemInput.js.map